<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="elevation-3">
          <v-card-text>
            <v-layout justify-center align-center>
              <v-flex xs12>
                <pivot
                  fields-label-text="Columnas activos"
                  columns-label-text="Totales activos"
                  available-colums-label-text="Totales disponibles"
                  available-fields-label-text="Columnas disponibles"
                  :data="data"
                  :filters="filters"
                  :fields-list="lists.fieldsList"
                  :columns-list="lists.columnsList"
                  :default-columns="defaultColumns"
                  @loading="clearData"
                  @loaded="setData">
                  <filters-bar
                    title="Productos"
                    title-class="headline"
                    :filters="filters"
                    :has-date-type="false"
                    :custom-filters="customFilters"
                    @search="applyFilters">
                      <template slot="content">
                        <v-flex md2 mr-3>
                          <v-btn
                            class="h-100 ma-0 w-100 btn-filter"
                            @click="generateReport">
                            <v-icon small>fas fa-download</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex md3 mr-3>
                          <v-select
                            solo
                            label="Tipo de moneda"
                            color="grey"
                            :items="currencies"
                            item-text="name"
                            item-value="id"
                            v-model="filters.currency">
                          </v-select>
                        </v-flex>
                      </template>
                  </filters-bar>
                </pivot>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import Pivot from '@/components/global/report_datatables/Pivot';
import FiltersBar from '@/components/global/FiltersBar';

export default {
  components: {
    Pivot,
    FiltersBar,
  },
  mounted() {
    this.getDims();
    this.$store.dispatch('GET_TRANCHE_STATUS');
  },
  data() {
    return {
      dialog: false,
      data: [],
      customFilters: [
        {
          text: 'Estado',
          value: 'workflow_status',
        },
        {
          text: 'Estado / Región',
          value: '',
        },
        {
          text: 'Agente',
          value: '',
        },
        {
          text: 'Genero',
          value: '',
        },
        {
          text: 'Estado del tramo',
          value: 'trancheStatus',
        },
      ],
      currencies: [],
      filters: {
        code: 'PDS',
        dateType: 'month',
        currency: null,
        date: moment().format('YYYY-MM'),
      },
      defaultColumns: [
        {
          label: 'Total',
          value: 'total',
        },
        {
          label: 'Saldo de deuda',
          value: 'due_balance',
        },
        {
          label: 'Saldo facturado',
          value: 'invoiced_balance',
        },
        {
          label: 'Saldo total',
          value: 'total_balance',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'dimentions',
    ]),
    dims() {
      if (this.dimentions.length) {
        return this.dimentions.map((item) => {
          const { title, name } = item;
          const obj = {};
          obj.label = title;
          obj.value = name;
          return obj;
        });
      }
      return [];
    },
    lists() {
      const lists = {
        fieldsList: [
          {
            label: 'Estado',
            value: 'workflow_status',
          },
          {
            label: 'Ultimo canal de gestión',
            value: 'last_n_channel_id',
          },
          {
            label: 'Ultimo canal de contacto',
            value: 'last_r_channel_id',
          },
          {
            label: 'Ultimo canal de contacto util',
            value: 'last_c_channel_id',
          },
          {
            label: 'Ultima promesa de pago',
            value: 'payment_promise',
          },
          {
            label: 'Ultima fecha de gestion',
            value: 'last_notification',
          },
          {
            label: 'Ultima fecha de contacto',
            value: 'last_reached',
          },
          {
            label: 'Ultima fecha de contacto util',
            value: 'last_contact',
          },
          {
            label: 'Estado del tramo',
            value: 'tranche_status',
          },
          {
            label: 'Agencia',
            value: 'agency',
          },
          {
            label: 'Tramo',
            value: 'tranche',
          },
          {
            label: 'Vencimiento',
            value: 'due_day',
          },
          {
            label: 'Cartera',
            value: 'portfolio_type',
          },
          {
            label: 'Tipo de cuenta',
            value: 'account_type',
          },
          {
            label: 'Última carga',
            value: 'last_sync_date',
          },
          {
            label: 'Fecha de vencimiento',
            value: 'due_date',
          },
          ...this.dims,
        ],
        columnsList: [
          {
            label: 'Saldo capital',
            value: 'principal_balance',
          },
          {
            label: 'Saldo provisionado',
            value: 'provision_balance',
          },
          {
            label: 'Saldo del prestamo',
            value: 'loan_amount',
          },
        ],
      };
      return lists;
    },
  },
  methods: {
    getDims() {
      this.axios.get('filters/currencies').then(({ data }) => {
        this.currencies.push(...data);
      });
    },
    generateReport() {
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: {
            ...this.filters,
          },
          functionName: 'bills',
        },
      });
    },
    clearData() {
      this.data = [];
      this.isDataLoading = true;
    },
    setData($event) {
      this.data = $event;
      this.isDataLoading = false;
    },
    applyFilters($event) {
      this.filters = {
        ...this.filters,
        ...$event,
      };
    },
  },
  watch: {
    currencies: {
      deep: true,
      handler(val) {
        this.filters.currency = val[0].id;
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/reports/product/Index.vue